import { FormattedMessage, useIntl } from 'react-intl'

import MarkdownRender from 'LuxKit/MarkdownRender'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import PropertyFinePrint from 'components/Common/BedbankPropertyFinePrint'
import type { ThingsToKnowLayoutMode } from 'components/Common/ThingsToKnow/ThingsToKnowLayout'
import PropertyThingsToKnow from 'components/OfferPage/ThingsToKnow/PropertyThingsToKnow'
import Group from 'components/utils/Group'

export function usesPropertyThingsToKnowLayout(property: App.Property.Property): boolean {
  return !!property.finePrintSubsections?.length
}

interface Props {
  property: App.Property.Property
  mode?: ThingsToKnowLayoutMode
}

function PropertyThingsToKnowContent({ property, mode }: Props) {
  const intl = useIntl()

  if (usesPropertyThingsToKnowLayout(property)) {
    return <PropertyThingsToKnow property={property} mode={mode} />
  }

  const { finePrint, structuredFinePrint, taxesAndFeesContent } = property

  return <Group direction="vertical" gap={20}>
    {!!taxesAndFeesContent && <Group direction="vertical" gap={12}>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: '8-SUD1oNGneIkEFxEHuU',
          defaultMessage: 'Taxes & fees:',
        })}
      </BodyText>
      <MarkdownRender type="compact" fontSize="medium" content={taxesAndFeesContent} />
    </Group>}
    <Group direction="vertical" gap={12}>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: 'rBKnRsQDvkFyzKmu_TWd',
          defaultMessage: 'Cancellation Policy',
        })}
      </BodyText>
      <BodyText variant="medium">
        <FormattedMessage
          id="FvyVjVL4R0Wz_fS2bBTM"
          defaultMessage="Please note cancellation policies vary depending on the rate selected, please choose your package carefully. See full <link>booking terms and conditions</link>"
          
          values={{
            link: (chunks) => <TextLink weight="regular" to="/booking-policies" target="_blank">{chunks}</TextLink>,
          }}
        />
      </BodyText>
    </Group>
    {finePrint && <MarkdownRender type="compact" fontSize="medium" content={finePrint} />}
    {!finePrint && structuredFinePrint && <PropertyFinePrint finePrint={structuredFinePrint} />}
  </Group>
}

export default PropertyThingsToKnowContent
